import type { Config as ConfigType } from './config.types';

declare const NEXT_PUBLIC_ENVIRONMENT: string;
declare const NEXT_PUBLIC_PLATFORM_URL: string;
declare const NEXT_PUBLIC_API_URL: string;
declare const NEXT_PUBLIC_LOQATE_API_KEY: string;
declare const NEXT_PUBLIC_APP_NAME: string;
declare const NEXT_PUBLIC_SECURE_STORAGE_ENCRYPTION_KEY: string;
declare const NEXT_PUBLIC_IMAGES_URL: string;
declare const NEXT_PUBLIC_LOBBY_BACKGROUND_IMAGE_URL: string;
declare const NEXT_PUBLIC_MKODO_API_KEY: string;
declare const NEXT_PUBLIC_MKODO_CONFIG_URL: string;
declare const NEXT_PUBLIC_MKODO_ENABLED: string;
declare const NEXT_PUBLIC_SENTRY_DSN: string;
declare const NEXT_PUBLIC_BETTY_WHEEL_URL: string;
declare const NEXT_PUBLIC_RECAPTCHA_KEY_WEB: string;
declare const NEXT_PUBLIC_APPSFLYER_CONFIG: string;
declare const NEXT_PUBLIC_SMARTICO_CONFIG: string;
declare const NEXT_PUBLIC_IOS_APP_STORE_ID: string;
declare const NEXT_PUBLIC_ANDROID_APP_STORE_ID: string;
declare const NEXT_PUBLIC_OTA_UPDATES_URL: string;
declare const NEXT_PUBLIC_ONFIDO_VERSION: string;
declare const NEXT_PUBLIC_FIREBASE_CONFIG_WEB: string;

export const Config: ConfigType = {
  ENVIRONMENT: String(NEXT_PUBLIC_ENVIRONMENT),
  PLATFORM_URL: String(NEXT_PUBLIC_PLATFORM_URL),
  API_URL: String(NEXT_PUBLIC_API_URL),
  LOQATE_API_KEY: String(NEXT_PUBLIC_LOQATE_API_KEY),
  APP_NAME: String(NEXT_PUBLIC_APP_NAME),
  SECURE_STORAGE_ENCRYPTION_KEY: String(
    NEXT_PUBLIC_SECURE_STORAGE_ENCRYPTION_KEY,
  ),
  IMAGES_URL: String(NEXT_PUBLIC_IMAGES_URL),
  LOBBY_BACKGROUND_IMAGE_URL: String(NEXT_PUBLIC_LOBBY_BACKGROUND_IMAGE_URL),
  MKODO_API_KEY: String(NEXT_PUBLIC_MKODO_API_KEY),
  MKODO_CONFIG_URL: String(NEXT_PUBLIC_MKODO_CONFIG_URL),
  MKODO_ENABLED: Boolean(NEXT_PUBLIC_MKODO_ENABLED),
  SENTRY_DSN: String(NEXT_PUBLIC_SENTRY_DSN),
  BETTY_WHEEL_URL: String(NEXT_PUBLIC_BETTY_WHEEL_URL),
  RECAPTCHA_KEY: String(NEXT_PUBLIC_RECAPTCHA_KEY_WEB),
  APPSFLYER_CONFIG: NEXT_PUBLIC_APPSFLYER_CONFIG
    ? String(NEXT_PUBLIC_APPSFLYER_CONFIG)
    : undefined,
  SMARTICO_CONFIG: NEXT_PUBLIC_SMARTICO_CONFIG
    ? String(NEXT_PUBLIC_SMARTICO_CONFIG)
    : undefined,
  IOS_APP_STORE_ID: NEXT_PUBLIC_IOS_APP_STORE_ID
    ? String(NEXT_PUBLIC_IOS_APP_STORE_ID)
    : undefined,
  ANDROID_APP_STORE_ID: NEXT_PUBLIC_ANDROID_APP_STORE_ID
    ? String(NEXT_PUBLIC_ANDROID_APP_STORE_ID)
    : undefined,
  OTA_UPDATES_URL: String(NEXT_PUBLIC_OTA_UPDATES_URL),
  ONFIDO_VERSION: String(NEXT_PUBLIC_ONFIDO_VERSION),
  FIREBASE_CONFIG_WEB: NEXT_PUBLIC_FIREBASE_CONFIG_WEB
    ? String(NEXT_PUBLIC_FIREBASE_CONFIG_WEB)
    : undefined,
};

export default Config;
